module.exports = __webpack_public_path__ + "static/media/Partner.d95348e2.jpg";